import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";

var _class, _descriptor, _descriptor2, _class2, _temp;

import _regeneratorRuntime from "@babel/runtime/regenerator";
import { RouteHttpVerb } from "../../factory";
import { observable, flow } from "mobx";
var ClientCollection = (_class = (_temp = _class2 = function ClientCollection() {
  var _this = this;

  _classCallCheck(this, ClientCollection);

  _initializerDefineProperty(this, "entries", _descriptor, this);

  _initializerDefineProperty(this, "busy", _descriptor2, this);

  this.annotated = void 0;
  this.get = flow( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
    var _ref, request, params, _ref$clear, clear, _this$annotated, path, namespace, _response, _iterator, _step, row, _instance, existing;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref = data || {}, request = _ref.request, params = _ref.params, _ref$clear = _ref.clear, clear = _ref$clear === void 0 ? false : _ref$clear;
            this.busy = true;
            _context.prev = 2;
            _this$annotated = this.annotated, path = _this$annotated.path, namespace = _this$annotated.namespace;
            _context.next = 6;
            return this.annotated.request({
              location: {
                path: path,
                method: RouteHttpVerb.GET,
                namespace: namespace
              },
              request: request,
              params: params
            });

          case 6:
            _response = _context.sent;
            // Save cookies as models
            clear && this.entries.clear();
            _iterator = _createForOfIteratorHelper(_response);

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                row = _step.value;
                _instance = this.instance(row);
                existing = this.entries.get(_instance.key);

                if (!existing) {
                  this.entries.set(_instance.key, _instance);
                } else {
                  // Update stale data
                  existing.data = _instance.data;
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            _context.next = 16;
            break;

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](2);
            console.log(_context.t0);
            throw _context.t0;

          case 16:
            _context.prev = 16;
            this.busy = false;
            return _context.finish(16);

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[2, 12, 16, 19]]);
  }));
  this.getSingle = flow( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data) {
    var _ref2, request, params, _this$annotated2, singlePath, namespace, row, _instance2;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (this.annotated.singlePath) {
              _context2.next = 2;
              break;
            }

            throw new Error("There is no getSingle method allowed");

          case 2:
            _ref2 = data || {}, request = _ref2.request, params = _ref2.params;
            this.busy = true;
            _context2.prev = 4;
            _this$annotated2 = this.annotated, singlePath = _this$annotated2.singlePath, namespace = _this$annotated2.namespace;
            _context2.next = 8;
            return this.annotated.request({
              location: {
                path: singlePath,
                method: RouteHttpVerb.GET,
                namespace: namespace
              },
              request: request,
              params: params
            });

          case 8:
            row = _context2.sent;
            // Save cookie as model
            _instance2 = this.instance(row);
            this.entries.set(_instance2.key, _instance2);
            _context2.next = 17;
            break;

          case 13:
            _context2.prev = 13;
            _context2.t0 = _context2["catch"](4);
            console.log(_context2.t0);
            throw _context2.t0;

          case 17:
            _context2.prev = 17;
            this.busy = false;
            return _context2.finish(17);

          case 20:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this, [[4, 13, 17, 20]]);
  }));
  setTimeout(function () {
    if (!_this.annotated) {
      console.error("You have not used the @ClientCollection.annotate annoation together with this class!");
    }
  }, 0);
}, _class2.annotate = function (annotate) {
  return function (constructor) {
    return /*#__PURE__*/function (_constructor) {
      _inherits(_class4, _constructor);

      var _super = _createSuper(_class4);

      function _class4() {
        var _this2;

        _classCallCheck(this, _class4);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this2 = _super.call.apply(_super, [this].concat(args));
        _this2.annotated = annotate;
        return _this2;
      }

      return _class4;
    }(constructor);
  };
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "entries", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return new Map();
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "busy", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
})), _class);
export { ClientCollection };